<script setup lang="ts">
import {defineProps} from 'vue'
const props = defineProps(
    {
  title:String,
  desc:String,
  menuList:[],
  imgDesc:String

})
</script>

<template>
  <li class="impx-menu-cat-group-wrapper">
    <div class="impx-menu-cat-group-outline"></div>
    <div class="impx-menu-page-group impx-menu-page-3col">
      <div class="uk-grid uk-grid-medium uk-margin-medium-bottom impx-margin-bottom">
        <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-2-3@m uk-width-4-5@s impx-menu-page-group-title">
          <h4 class="uk-margin-remove">{{props.title}}</h4>
          <p>{{props.desc}}</p>
        </div>
        <div class="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-5@s uk-container-center">
          <img :src="props.imgDesc" alt="Menu Resto" class="uk-border-circle uk-align-center" />
        </div>
      </div>
      <ul class="impx-menu-page menu-list">
        <li v-for="(menu,index) in props.menuList" :key="index">
          <div class="impx-menu-page-item">
            <div class="impx-menu-page-content">
              <h5>{{menu.title}}</h5>
              <div class="impx-menu-page-price">
                <h5>{{menu.price}} CFA</h5>
              </div>
              <p>{{menu.subtitle}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </li>

</template>

<style scoped>

</style>